<template>
    <ValidationObserver
        ref="fixIt"
        v-slot="{ passes }"
    >
        <BaseDialog
            :showDialog="showDialog"
            headline="lang_GENERIC_CAPTION_FIX_IT"
            :close="closeDialog"
            maxDialogWidth="900"
            maxCardHeight="600"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <BaseEditPageAutocomplete 
                                :context="context"
                                field="Ykto"
                                :label="$t('lang_PUBLISHING_INCOME_CAPTION_FIX_IT_ASSIGN_KTO')"
                                :withMargin="false"
                                rules="required"
                                :additionalFunction="ktoSelected"
                                :alvqa="alvqa + '-autocomplete-ykto-textfield'"
                            >
                                <template v-slot:selection="{ item }">
                                    <div class="ellipsis" :alvqa="alvqa + '-autocomplete-ykto-selection'">
                                        {{ 
                                            typeof item === 'object' ? 
                                                getKtoName(item) : item 
                                        }}
                                    </div>
                                </template>
                                <template v-slot:items="{ items }">
                                    <v-list-item-content :alvqa="alvqa + '-autocomplete-ykto-dropdown-' + items.alvId">
                                        <v-list-item-title :alvqa="alvqa + '-autocomplete-ykto-dropdown-' + items.alvId + '-title'">
                                            {{ items.gemaName }} ({{ items.alvId }}) [KTO: {{ items.metadata.ykto }} - {{ items.metadata.hkto }} - {{ items.metadata.ukto }}]
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </BaseEditPageAutocomplete>
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <!-- APPLY button -->
            <template v-slot:dialogActions>
                <v-container fluid>
                    <v-row>
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                :disabled="disableApplyButton"
                                label="lang_GENERIC_CAPTION_APPLY"
                                @click="passes(apply)"
                                :alvqa="alvqa+'-button-apply'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'

export default {
    name: "FixItDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageAutocomplete,
    },
    data() {
        return {
            context: "FixIt",
            alvqa: 'publishing-income-list-dialog-fix-it',
            disableApplyButton: true,
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowFixItDialog },
            set(show) { this.$store.commit('setShowFixItDialog', show) }
        },  
        ktoSelected() {
            if (this.$store.getters.getFixItDetailsYkto == null)
                this.disableApplyButton = true
            else
                this.disableApplyButton = false
        },
    },
    methods: {
        closeDialog() {
            this.showDialog = false
        },
        getKtoName(item) {
            return item.gemaName + ' (' + item.ykto + '-' + item.hkto + '-' + item.ukto + ' | ' + item.alvId + ')'
        },
        apply() {
            this.disableApplyButton = true
            this.$store.dispatch('fixIt')
        },
    },
}
</script>